import { Badge, Flex, Text } from '@radix-ui/themes';

interface CategoryHeadingProps {
  title: string;
  count?: number;
}

const CategoryHeading = ({ title, count }: CategoryHeadingProps) => (
  <Flex align="center" justify="between">
    <Text
      size="1"
      weight="medium"
      style={{ textTransform: 'uppercase' }}
      color="gray"
    >
      {title}
    </Text>
    {count !== undefined && (
      <Badge size="1" variant="soft" color="gray" radius="full">
        {count}
      </Badge>
    )}
  </Flex>
);

type CategorySectionProps = CategoryHeadingProps & {
  children: React.ReactNode;
};

const CategorySection = ({ title, count, children }: CategorySectionProps) => (
  <Flex direction="column" m="3" gap="0.5rem">
    <CategoryHeading title={title} count={count} />
    {children}
  </Flex>
);

export default CategorySection;
